const actions = {
  SET_STATE: 'virtualSettings/SET_STATE',
  CHANGE_SETTING: 'virtualSettings/CHANGE_SETTING',
}

export default actions
